import React, { useState } from "react";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

// Convenient date field: type directly (YYYY-MM-DD) OR pick from a calendar
// with quick month + year dropdown navigation.
const DateField = ({ value, onChange, placeholder = "YYYY-MM-DD" }) => {
  const [open, setOpen] = useState(false);
  const parsed = value ? new Date(value) : undefined;
  const valid = parsed && !isNaN(parsed.getTime());

  return (
    <div className="relative">
      <input
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full h-9 pl-3 pr-9 text-sm border border-gray-300 rounded bg-white outline-none focus:border-[#1877c9]"
      />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" className="absolute right-1 top-1/2 -translate-y-1/2 p-1.5 text-gray-400 hover:text-[#1877c9]">
            <CalendarIcon size={16} />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar
            mode="single"
            captionLayout="dropdown-buttons"
            fromYear={1990}
            toYear={2035}
            defaultMonth={valid ? parsed : new Date()}
            selected={valid ? parsed : undefined}
            classNames={{
              caption_dropdowns: "flex gap-1",
              dropdown: "border border-gray-300 rounded px-1 py-1 text-sm bg-white outline-none focus:border-[#1877c9] cursor-pointer",
              caption_label: "hidden",
            }}
            onSelect={(d) => {
              onChange(d ? format(d, "yyyy-MM-dd") : "");
              setOpen(false);
            }}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default DateField;
